import React, { useCallback } from 'react'
import { useStore } from 'core'

import './style.scss'

import Icon from 'components/Icon'

const classes = {
  wrapper: 'PipelineMenuButton-wrapper',
}

const PipelineMenuButton = props => {
  const { activePipeline, openPipelineManager, closePipelineManager } = useStore(
    'selectActivePipeline',
    'openPipelineManager',
    'closePipelineManager'
  )
  const { id, open, title } = activePipeline

  const pipelineManagerToggle = useCallback(() => {
    if (open) closePipelineManager()
    else openPipelineManager()
  }, [open, closePipelineManager, openPipelineManager])

  if (!id) return null
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      // eslint-disable-next-line no-script-url
      href="javascript:void(0)"
      className={classes.wrapper}
      data-active={open}
      onClick={pipelineManagerToggle}
    >
      <Icon type="merge" />
      <span>{title || 'Pipeline Manager'}</span>
    </a>
  )
}

export default PipelineMenuButton
